import React, { useState, useContext } from 'react';
import PropTypes from 'prop-types';
import { activateLoader, deactivateLoader, showMessage } from 'utilities';
import { cancelAppointment } from 'requests';
import ButtonLink from 'components/ui/buttons/ButtonLink';
import Button from 'components/ui/buttons/Button';
import Flex from 'components/ui/Flex';
import FlexItem from 'components/ui/FlexItem';
import Modal from 'components/ui/Modal';
import AnalyticsContext from 'components/shared/analytics/AnalyticsContext';
import { ANALYTICS } from 'consts';
import InterviewContext from './InterviewContext';
import { useMediaSet } from 'use-media-set';
import { mediaSetQueries, colors } from 'styleGuide';

const CancelInterviewButton = props => {
  const mediaStates = useMediaSet(mediaSetQueries);
  const isMobile = mediaStates.has('mobileOrLaptopS');

  const { trackEvents } = useContext(AnalyticsContext);
  const dispatch = useContext(InterviewContext);
  const [showModal, setShowModal] = useState(false);
  const handleCloseModal = () => setShowModal(false);
  const handleShowModal = () => setShowModal(true);
  const handleCancelInterview = () => {
    trackEvents &&
      trackEvents(ANALYTICS.EVENT_TYPES.Custom)({ action: 'Cancel interview' });
    activateLoader();
    handleCloseModal();
    deactivateLoader();
    cancelAppointment(props.cancelLink)
      .then(() => {
        handleCloseModal();
        dispatch({ type: 'cancel', interview: props.interview });
        deactivateLoader();
      })
      .catch(error => {
        deactivateLoader();
        showMessage(`An error has occurred: ${error}`, true);
      });
  };
  return (
    <>
      <ButtonLink id="show-modal" onClick={handleShowModal}>
        <i className="fa fa-remove" aria-hidden="true" /> Cancel
      </ButtonLink>
      <Modal onHide={handleCloseModal} show={showModal}>
        <div className="mt-5 pl-3 pr-3">
          <h2>Are you sure you want to cancel this interview?</h2>
          <p className="mt-3 mb-5">
            If you cancel the interview, we&apos;ll send an email to the
            candidate on your behalf.
          </p>
          <Flex
            alignItems={isMobile ? 'stretch' : 'center'}
            className="w-100"
            direction={isMobile ? 'column' : 'row'}
            gap={16}
            justifyContent={isMobile ? 'flex-start' : 'flex-end'}
          >
            <FlexItem grow={1} order={isMobile ? 3 : 1}>
              <Button
                size={isMobile ? 'md' : `sm`}
                block={isMobile}
                className={mediaStates.has('mobileOrSmTablet') ? null : `px-5`}
                id="cancel"
                secondary={true}
                onClick={handleCloseModal}
              >
                Keep interview
              </Button>
            </FlexItem>

            <FlexItem align="stretch" order={isMobile ? 1 : 3}>
              <Button
                size={isMobile ? 'md' : `sm`}
                block={isMobile}
                className={mediaStates.has('mobileOrSmTablet') ? null : `px-5`}
                id="confirm"
                style={{ backgroundColor: colors.error }}
                onClick={handleCancelInterview}
              >
                Cancel interview
              </Button>
            </FlexItem>
          </Flex>
        </div>
      </Modal>
    </>
  );
};

CancelInterviewButton.propTypes = {
  interview: PropTypes.object.isRequired,
  cancelLink: PropTypes.string.isRequired,
};

export default CancelInterviewButton;
